module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "piccolumn1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._l((_vm.photosurl), function(item, index) {
    return _c('div', {
      key: item.ID,
      staticStyle: {
        "position": "relative",
        "width": "15vh",
        "margin-right": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "text-align": "right",
        "z-index": "2",
        "float": "right",
        "top": "0px",
        "right": "0px"
      },
      on: {
        "click": function($event) {
          return _vm.deletepic(index)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": require("../../../../static/images/icon_delete.png")
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "viewer",
        rawName: "v-viewer"
      }]
    }, [_c('img', {
      staticStyle: {
        "width": "15vh",
        "height": "12.5vh"
      },
      attrs: {
        "src": item.path
      }
    })])])
  }), _vm._v(" "), _c('Upload', {
    ref: "upload",
    staticStyle: {
      "width": "114px"
    },
    attrs: {
      "multiple": "",
      "show-upload-list": false,
      "before-upload": _vm.handleBeforeUpload,
      "on-success": _vm.uplloadSucess,
      "format": ['jpg', 'png'],
      "action": _vm.uploadUrl,
      "data": _vm.uploadData,
      "type": "drag"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0.5vh",
      "height": "12vh"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload-outline",
      "size": "42"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "height": "46px",
      "line-height": "16px"
    }
  }, [_vm._v("图片拖至此处或者单击选择图片")])], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0999561e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/unit/imgUpload.vue
// module id = 1066
// module chunks = 1